<div class="component-container flex flex-col justify-center items-center w-full p-[2.5rem]">
  <mat-expansion-panel
    [expanded]="true"
    class="mat-elevation-z0 expansion-panel w-full"
  >
    <mat-expansion-panel-header class="flex flex-row justify-center items-center w-full">
      <div class="title">
        Group Sessions
      </div>
    </mat-expansion-panel-header>

    <div class="w-full xs:overflow-x-auto sm:overflow-x-auto">
      <div
        class="table-wrapper overflow-auto xs:h-[calc(100vh-33rem)] sm:h-[calc(100vh-33rem)] md:h-[calc(100vh-19rem)]">
        <table
          *ngIf="dataSource?.length"
          [dataSource]="dataSource"
          class="mat-elevation-z8"
          mat-table
        >
          <!--SESSIONS-->
          <ng-container
            [sticky]="true"
            matColumnDef="session"
          >
            <th
              *matHeaderCellDef
              class="min-w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Session
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell">
                <span
                  (click)="handleSessionClick(eachRow)"
                  class="session-number clickable"
                >
                  Session {{ eachRow.sessionNumber }}
                </span>
              </div>
            </td>
          </ng-container>
          <!--DESCRIPTION-->
          <ng-container
            matColumnDef="description"
          >
            <th
              *matHeaderCellDef
              class="min-w-[30rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Description
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div
                class="td-cell flex flex-col gap-[0.5rem] p-[1rem]"
              >
                <span class="description">{{ eachRow.sessionName }}</span>
              </div>
            </td>
          </ng-container>
          <!--DATE-->
          <ng-container
            matColumnDef="date"
          >
            <th
              *matHeaderCellDef
              class="min-w-[15rem]"
              mat-header-cell
            >
              <div class="th-cell">
                <span>Date</span>
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell">
                {{ eachRow.meetingOn| date:'MM/dd/YYYY' }}
              </div>
            </td>
          </ng-container>
          <!--START TIME-->
          <ng-container
            matColumnDef="startTime"
          >
            <th
              *matHeaderCellDef
              class="min-w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Start Time
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell">
                {{ eachRow.meetingOn | date: 'hh:mm a' }}
              </div>
            </td>
          </ng-container>
          <!--DURATION-->
          <ng-container
            matColumnDef="duration"
          >
            <th
              *matHeaderCellDef
              class="min-w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Duration
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell">
                {{ eachRow.duration ? eachRow.duration + ' mins' : '' }}
              </div>
            </td>
          </ng-container>
          <!--GROUP FORMAT-->
          <ng-container
            matColumnDef="format"
          >
            <th
              *matHeaderCellDef
              class="min-w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Group Format
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell">
                {{ sessionFormatLabelMap[eachRow.format] }}
              </div>
            </td>
          </ng-container>
          <!--SESSION DELIVERY-->
          <ng-container
            matColumnDef="locationName"
          >
            <th
              *matHeaderCellDef
              class="min-w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Session Delivery
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell">
                {{ eachRow.locationName }}
              </div>
            </td>
          </ng-container>
          <!--ATTENDANCE-->
          <ng-container
            matColumnDef="attendance"
          >
            <th
              *matHeaderCellDef
              class="min-w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell">
                Attendance
              </div>
            </th>
            <td *matCellDef="let eachRow"
                mat-cell>
              <div class="td-cell">
                {{ eachRow.presentParticipantCount }}
                of {{ eachRow.totalParticipantCount }}
              </div>
            </td>
          </ng-container>
          <!--ACTION MENU-->
          <ng-container
            matColumnDef="actionMenu">
            <th
              *matHeaderCellDef
              mat-header-cell
            >
            </th>
            <td *matCellDef="let eachRow"
                class="w-[10rem]"
                mat-cell>
              <button
                [matMenuTriggerFor]="menu"
                mat-icon-button
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <div *ngIf="!eachRow?.isComplete; else complete">
                  <ng-container
                    *ngFor="let childMenu of actionMenuForCloseSession"
                  >
                    <button
                      (click)="childMenu.handleClick(eachRow)"
                      mat-menu-item
                    >
                      <span class=" ">{{ childMenu.displayName }}</span>
                    </button>
                  </ng-container>
                </div>
                <ng-template
                  #complete
                >
                  <div>
                    <ng-container
                      *ngFor="let childMenu of actionMenuForRestartSession"
                    >
                      <button
                        (click)="childMenu.handleClick(eachRow)"
                        mat-menu-item
                      >
                        <span class=" ">{{ childMenu.displayName }}</span>
                      </button>
                    </ng-container>
                  </div>
                </ng-template>
              </mat-menu>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns; sticky: true"
              mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns;"
              mat-row></tr>

        </table>
        <div
          *ngIf="loading"
          class="loading-section"
        >
          <mat-spinner
            mode="indeterminate"
          >
          </mat-spinner>
        </div>
      </div>
    </div>
  </mat-expansion-panel>

</div>
